<layer-header (closeLayer)="closeLayer()"
              (setListView)="setListView($event)"
              [listToggle]="listToggle"
              [title]="'Collection Places'">
    <ng-content></ng-content>
</layer-header>
<service-location-edit *ngIf="topLayer == 'edit'"
                         [serviceId]="serviceId"
                         [registration]="registration"
                         [determinantMapById]="determinantMapById"
                         [serviceLocation]="serviceLocation"
                         [registrationServiceLocation]="registrationServiceLocation"
                         (editCancel)="cancelEdit($event);"
                         (formSubmit)="submitEdit($event);"
                         class="row layer sub-layer px-3 pt-1">
</service-location-edit>
<determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
                 class="row layer sub-layer px-3 pt-1"
                 [serviceId]="serviceId"
                 [determinant]="store.state.common.determinantSection.determinant"
                 (formSubmit)="closeDetLayer()"
                 (editCancel)="closeDetLayer()"></determinant-new>
<div class="row mb-3 pr-3 {{showDeterminantBuilder ? '' : 'hidden'}}">
    <div class="col-12 mb-4">
        <primary-text-button (click)="updateRegistrationServiceLocation(registrationServiceLocation)">
            {{'Save' | translate }}
        </primary-text-button>
        <cancelary-text-button (click)="closeLayer()"
                                [noRightMargin]=true>
            {{'Cancel' | translate }}
        </cancelary-text-button>
    </div>
</div>
<div class="row mb-3 pr-3 {{showDeterminantBuilder ? 'hidden' : ''}}">
    <div class="col-md-1">
    </div>
    <div class="col-lg-12 col-xl-11">
        <!-- Search -->
        <div class="row">
            <div class="col-md-12 col-xl-6">
                <div class="form-controller list-search-container">
                    <i class="fas fa-search list-search-icon"></i>
                    <input type="text"
                           [(ngModel)]="userFilter.name"
                           placeholder="{{ 'general.search' | translate }}"
                           class="form-control list-search-input flew-grow-1">
                    <button class="btn btn-sm btn-primary mr-1"
                       (click)="openEdit(false);$event.stopPropagation();"
                       placement="left"
                       aria-hidden="true">{{'Add' | translate}}</button>
                </div>
            </div>
        </div>
        <!-- Listing -->
        <div class="{{listToggle ? 'cards-list' : 'rows-list'}} row"
             style="margin-bottom:2rem">
            <div *ngFor="let serviceLocation of serviceLocations | filterBy: userFilter; let i = index"
                 class="nglist-item {{listToggle ? 'col-sm-6 col-md-4 col-lg-3' : 'col-md-12 col-xl-6'}}"
                 (click)="openEdit(serviceLocation);$event.stopPropagation();">
                <div class="nglist-item-content">
                    <span class="nglist-item-content-title">
                      {{serviceLocation.name}}
                    </span>
                </div>
                <div class="nglist-item-actions alternate">
                    <icon style="margin-inline-end:0.5rem;"
                          className="far fa-circle toggle__icon"
                          *ngIf="!isActive(serviceLocation)"
                          (click)="saveRegistrationServiceLocation(serviceLocation);$event.stopPropagation()"></icon>
                    <icon style="margin-inline-end: 0.5rem;color:#8ecb35;cursor:pointer"
                          className="fas fa-check icon-success"
                          *ngIf="isActive(serviceLocation)"
                          (click)="deleteRegistrationServiceLocation(serviceLocation);$event.stopPropagation()"></icon>
                    <confirmation [showTrashIcon]="true"
                                  [question]="'confirm.areyousure'"
                                  [extraClasses]="'nglist-item-action'"
                                  (click)="$event.stopPropagation()"
                                  (isConfirmed)="deleteServiceLocation($event, serviceLocation)"></confirmation>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row mb-3 pr-3 {{showDeterminantBuilder ? '' : 'hidden'}}">
    <div class="col-12 mb-4">
        <primary-text-button (click)="updateRegistrationServiceLocation(registrationServiceLocation)">
            {{'Save' | translate }}
        </primary-text-button>
        <cancelary-text-button (click)="closeLayer()"
                               [noRightMargin]=true>
            {{'Cancel' | translate }}
        </cancelary-text-button>
    </div>
</div>
<div class="row mb-3 pr-3 {{showDeterminantBuilder ? '' : 'hidden'}}">
    <div class="col-6">
        <determinant-list [groupsLength]="{value: registrationServiceLocation.jsonDeterminants}" [prefix]="'sll'"
                          [determinantMapById]="determinantMapById" [addDeterminantTo]="appendDeterminant"></determinant-list>
    </div>
    <div class="col-6 py-2 pb-3" style="background-color:#ccd2d8">
        <query-builder *ngIf="registrationServiceLocation && determinantMapById != null" [determinantMapById]="determinantMapById"
                       [prefix]="'sll'"
                       [jsonString]="registrationServiceLocation.jsonDeterminants"
                       (onChange)="registrationServiceLocation.jsonDeterminants = $event.jsonString"></query-builder>
    </div>
</div>
